<template>
    <div>
        <o-table
            :class="projectId ? 'project-width-table' : 'fullwidth-table'"
            class="is-responsive is-responsive-wide"
            
            :data="activities"

            :bordered="table.bordered"
            :striped="table.striped"
            :narrowed="table.narrowed"
            :mobile-cards="table.mobileCards"
            :paginated="table.paginated"
            :pagination-simple="table.paginationSimple"
            :per-page="table.perPage"
            :default-sort="table.defaultSort"

            :selected.sync="selected"
            @update:checkedRows="$event => checkedRows = $event"

            :loading="loading"
            :total="activities.length"
            backend-sorting
            backend-pagination
            @page-change="onPageChange"
            @sort="onSort"
        >
            <template>
                <o-table-column field="actor_id" label="User" sortable #default="{ row }">
                    {{ userNameById(row.actor_id) }}
                </o-table-column>

                <o-table-column field="action" label="Action" sortable #default="{ row }">
                    <a @click.prevent="changeRoute(row)">
                        {{ $filters.valueOrDefault(getActivityMessage(row),'Note has been created') }}
                    </a>
                </o-table-column>

                <o-table-column field="description" label="Description" sortable #default="{ row }">
                    {{ $filters.limit($filters.stripTags(activityDescriptionById(row.reference_type, row.reference_id)),200) }}
                </o-table-column>

                <o-table-column field="created_at" label="Created At" sortable #default="{ row }">
                    {{ $filters.datetime(row.created_at) }}
                </o-table-column>
            </template>

          <template v-slot:empty>
            <div class="has-text-centered">
              No milestones are logged yet
            </div>
          </template>
        </o-table>
        <div>Total: <strong>{{ activities.length }}</strong></div>
    </div>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'
    import Table from './../mixins/Table'

    export default {
        mixins: [Table],

        props: ['referenceType', 'referenceId', 'projectId'],

        data () {
            return {
                // table: {
                //     defaultSort: ['created_at', 'desc']
                // },
                moment,
                activities: []
            }
        },

        computed: {
            ...mapGetters([
                'activityDescriptionById',
                'activityReferenceById',
                'activityById',
                'userNameById'
            ]),

            ...mapGetters({
                itemsByIds: 'activitiesByIds'
            })
        },

        created () {
            this.filters = {
                reference_type: this.referenceType,
                reference_id: this.referenceId,
                project_id: this.projectId
            }

          this.fetchPaginatedData()

        },

        mounted () {
            this.fetchActivities({ project_id: this.$route.params.slug })
                .then((value) => {
                  value.data.data.map((activity) => {
                    if (this.activityReferenceById(activity.reference_type, activity.reference_id).is_milestone === 1){
                      this.activities.push(activity)
                    }
                  })
                })

            $('.checkbox-cell').click((e) => {
                e.stopPropagation()
            })
        },

        methods: {
            ...mapActions({
                fetchData: 'fetchActivities'
            }),
            ...mapActions(['fetchActivities']),

            getActivityMessage(row) {
                let reference = null

                if (row.reference_type === 'note') {
                    reference = this.activityReferenceById(row.reference_type, row.reference_id)
                }
                return (reference && reference.is_milestone)
                    ? reference.subject
                    : row.action
            },

            changeRoute (row) {
                let route = null

                if (['change-order', 'note', 'contact'].includes(row.reference_type)) {
                    route = { name: `projects.show.${row.reference_type}s`, params: { slug: row.project_id } }
                    this.$emit('tab-changed', route)
                } else {
                    this.$router.push({ name: `${row.reference_type}s.show`, params: { slug: row.reference_id } })
                }
            }
        }
    }
</script>
